import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { themeSelector } from '@/state/config';
import styles from './PoweredBy.module.scss';
export const PoweredBy = memo(() => {
    const { t } = useTranslation();
    const theme = useRecoilValue(themeSelector);
    return (_jsxs("span", { className: cn(styles.container, styles[theme]), children: [t('we_run_on'), ' ', _jsx("a", { className: cn(styles.link), href: "https://moveo.ai?ref=web-client", target: "_blank", rel: "noreferrer", children: t('moveo_ai') })] }));
});
PoweredBy.displayName = 'PoweredBy';
